<template>
  <div class="index_banner_nav w1200 clearfix">
    <div class="quanfen clearfix">
      <span @click="showAllCate()">全部商品分类</span>
      <ul class="zk_con" v-if="isShow" @mouseleave="leave()">
        <li v-for="(item,index) in Navigation" :key="index">
          <img :src="item.recommend_img" width="30" style="float:left;margin-left: 15px;margin-top:8px;"/>
          <router-link :to="{path:'/Classify',query:{ grand_id:item.id }}" @mouseenter.native="showChildren(index)">{{ item.title }}</router-link>
          <ul class="index_pro" v-show="isTrue">
            <li v-for="(i,u) in tchildren" :key="u">
              <span>
                <router-link :to="{path:'/Classify',query:{ parent_id:i.id }}">{{ i.title }}</router-link>
                <img src="../assets/images/zp_49.png">
              </span>
              <div>
                <template v-for="(j,y) in i.children">
                  <router-link :to="{path:'/Goods',query:{ cid:j.id }}" :key="y">{{ j.title }}</router-link>
                  <br v-if="j.new_line==1" :key="y"/>
                </template>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="index_banner_nav_r">
      <ul class="clearfix">
        <li :class="toptNavi==1?'on':''"><router-link :to="{path:'/'}" title="首页">首页</router-link></li>
        <!-- <li :class="toptNavi==9?'on':''"><router-link :to="{path:'/Scenehall'}" title="场景馆">场景馆</router-link></li> -->
        <li :class="toptNavi==2?'on':''"><router-link :to="{path:'/Brand'}">品牌中心</router-link></li>
        <!-- <li :class="toptNavi==3?'on':''"><router-link :to="{path:'/Faster?id=3'}">快速下单</router-link></li> -->
        <!-- <li :class="toptNavi==4?'on':''"><router-link :to="{path:'/News'}" title="新闻资讯">新闻资讯</router-link></li> -->
        <li :class="toptNavi==7?'on':''"><router-link :to="{path:'/Honor'}" title="荣誉资质">荣誉资质</router-link></li>
        <li :class="toptNavi==5?'on':''"><router-link :to="{path:'/Resources'}" title="产品知识">产品知识</router-link></li>
        <!-- <li><router-link :to="{path:'/Hotcake'}" title="应急包">应急包</router-link></li> -->
        <!-- <li :class="toptNavi==5?'on':''"><router-link :to="{path:'/About'}" title="公司介绍">公司介绍</router-link></li> -->
        <li :class="toptNavi==6?'on':''"><router-link :to="{path:'/Supplier'}" title="供应商合作">供应商合作</router-link></li>
        <!-- <li :class="toptNavi==8?'on':''"><router-link :to="{path:'/Statistics'}" title="数据统计">数据统计</router-link></li> -->
        <li :class="toptNavi==10?'on':''"><router-link :to="{path:'/Dynamic'}" title="公司动态">公司动态</router-link></li>
        <li v-if="current_user.id && current_user.led_type==2"><router-link :to="{path:'/Ledcontrol'}" title="智能仓储">智能仓储</router-link></li>
        <li v-else><router-link :to="{path:'/LedIntroduce'}" title="智能仓储">智能仓储</router-link></li>
      </ul>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Navigationzj',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    toptNavi: ''
  },
  data () {
    return {
      cateGroyList: {},
      tchildren: {},
      isTrue: false,
      isShow: false
    }
  },
  computed: {
    ...mapGetters([
      'Navigation',
      'current_user'
    ])
  },
  mounted () {
    this.isShow = this.visible
    // 导航分类请求
    this.$store.dispatch('navigation/getCateGroyList')
  },
  methods: {
    showChildren (index) {
      this.isTrue = true
      this.tchildren = this.Navigation[index].children
    },
    leave () {
      this.isTrue = false
    },
    showAllCate () {
      this.isShow = !this.isShow
      // // this.$emit('visible', true)
      // this.$emit('update:visible', this.visible)
      // console.info(this.visible)
    }
  }
}
</script>

<!-- 添加“scoped”属性来限制CSS只适用于此组件 -->
<style scoped>
  .showOrheid {
    display: block;
  }
  .index_banner_nav_r ul li{
    flex: 1;
  }
  .index_banner_nav_r ul{
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/Navigationzj.vue